// ルール
const rules = {
  category: {
    required: true
  },
  lastname: {
    required: true
  },
  firstname: {
    required: true
  },
  lastnameKana: {
    required: true
  },
  firstnameKana: {
    required: true
  },
  tel: {
    required: true
  },
  email: {
    required: true
  },
  contents: {
    required: true
  }
}

// メッセージ
const messages = {
  category: {
    required: '選択してください'
  },
  lastname: {
    required: '入力してください'
  },
  firstname: {
    required: '入力してください'
  },
  lastnameKana: {
    required: '入力してください'
  },
  firstnameKana: {
    required: '入力してください'
  },
  tel: {
    required: '入力してください',
    tel: '電話番号を正確に入力してください'
  },
  email: {
    required: '入力してください',
    mail: 'メールアドレスを正確に入力してください'
  },
  contents: {
    required: '入力してください'
  }
}

// 追加ルールの定義
const methods = {
  tel: function tel( value, element ) {
    // 電話番号のバリデーション
    return this.optional(element) || /^\d{10,11}$/.test(value);
  },
  mail: function mail( value, element ) {
    // メールアドレスのバリデーション
    return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
  }
}

// メソッドの追加（上記の追加ルールを適用させる）
$.each( methods, function( key ) {
  $.validator.addMethod( key, this );
});



document.addEventListener('DOMContentLoaded', function(){

  // jQuery Validation Plugin の初期化
  $('#contactForm').validate({
    rules    : rules,
    messages : messages,
    // 複数項目のグループ化
    groups: {
      fullName      : 'lastname firstname',
      fullNameKana  : 'lastnameKana firstnameKana'
    },
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element ){
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element ){
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' )

      if ( element.attr('name') == 'lastname' || element.attr('name') == 'firstname' ) {
        error.prependTo('#fullName_error');
      } else if ( element.attr('name') == 'lastnameKana' || element.attr('name') == 'firstnameKana' ) {
        error.prependTo('#fullNameKana_error');
      } else {
        error.prependTo( eleName + '_error' );
      }
    }
  });

});
